import { createSelector } from 'reselect';


export function getPracticesEfectorVisits(state) {
  return state.practicesefectoresvisits;
}

export function getPracticeEfectoresById(state, practicePracticeEfectorVisitsId) {
  return getPracticesEfectorVisits(state).get(practicePracticeEfectorVisitsId);
}

//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentPracticeEfectorVisits = createSelector(
  getPracticesEfectorVisits,
  practicesefectoresvisits => practicesefectoresvisits.get(practicesefectoresvisits.get('currentPracticePracticeEfectorVisitsId'))
);
